import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-8 sm:h-16 bg-gray-100 dark:bg-gray-700" }
const _hoisted_2 = {
  class: "divider",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 24 150 28 ",
  preserveAspectRatio: "none"
}
const _hoisted_3 = { class: "parallax1" }
const _hoisted_4 = ["fill"]
const _hoisted_5 = { class: "parallax2" }
const _hoisted_6 = ["fill"]
const _hoisted_7 = { class: "parallax3" }
const _hoisted_8 = ["fill"]
const _hoisted_9 = { class: "parallax4" }
const _hoisted_10 = ["fill"]

import colors from 'tailwindcss/colors'
import { computed, Ref, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Divider',
  setup(__props) {

const theme: Ref<string> = ref(localStorage.theme === 'dark' ? 'dark' : 'light');
window.addEventListener('theme-changed', (event: CustomEvent<{ theme: string }>) => {
  theme.value = event.detail.theme;
});

const bgColor = computed(() => theme.value === 'dark' ? colors.neutral[800] : colors.white)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("defs", null, [
        _createElementVNode("path", {
          id: "gentle-wave",
          d: "M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
        })
      ], -1)),
      _createElementVNode("g", _hoisted_3, [
        _createElementVNode("use", {
          "xlink:href": "#gentle-wave",
          x: "50",
          y: "3",
          fill: _unref(colors).green[400]
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("g", _hoisted_5, [
        _createElementVNode("use", {
          "xlink:href": "#gentle-wave",
          x: "50",
          y: "0",
          fill: _unref(colors).green[500]
        }, null, 8, _hoisted_6)
      ]),
      _createElementVNode("g", _hoisted_7, [
        _createElementVNode("use", {
          "xlink:href": "#gentle-wave",
          x: "50",
          y: "9",
          fill: _unref(colors).green[600]
        }, null, 8, _hoisted_8)
      ]),
      _createElementVNode("g", _hoisted_9, [
        _createElementVNode("use", {
          "xlink:href": "#gentle-wave",
          x: "50",
          y: "6",
          fill: bgColor.value
        }, null, 8, _hoisted_10)
      ])
    ]))
  ]))
}
}

})